import cfg from 'cfg';
import { requestAsync } from 'redux-query';
import qs from 'query-string';
import { STORE_KEYS } from '../constants';
import { createApiFetchById } from './helpers';
import { teamsKeyBySportAndTtId } from '../selectors';

const ss2 = cfg.apis.ss2;

export const fetchTeamById = teamId => {
    const url = ss2 + '/teams/' + teamId;
    return createApiFetchById({
        id: teamId,
        url,
        key: STORE_KEYS.TEAMS
    });
};

export const fetchTeamsBySportAndLeague = ({ sportId, tournamentId }) => {
    const key = teamsKeyBySportAndTtId(sportId, tournamentId);
    const query = qs.stringify({
        ttId: tournamentId,
        sportId
    });
    let url = `${ss2}/teams?${query}`;
    if (tournamentId) {
        url = `${ss2}/tournaments/${tournamentId}/teams`;
    }

    return requestAsync({
        url,
        queryKey: key,
        force: true,
        transform: teams => ({
            [key]: teams.map(team => team.id),
            teams: teams.reduce((acc, cur) => {
                acc[cur.id] = cur;
                return acc;
            }, {})
        }),
        update: {
            [key]: (prev, next) => next,
            teams: (prev, next) => ({ ...prev, ...next })
        }
    });
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/actions/teams.js
 **/